import { Component, OnInit, Input, ElementRef, ViewChild } from '@angular/core';
import { Plate } from '../models/plate';
import { MessagesService } from '../messages/messages.service';
import { Step } from '../models/step';
import { ErrorHandler } from '../utils/error-handler';
import { ProcessStepStage } from '../models/process-step-stages';
import { StepAction } from '../models/step-action';
import { MaPlatePreparationService } from '../ma-plate-preparation/ma-plate-preparation.service';
import { BeadChipProcessStep, BeadChipStatus } from '../models/process-step';
import { BeadChipAction } from '../models/action';
import { BeadChip } from '../models/bead-chip';
import { Comment } from '../models/comment';
import { BeadchipService } from './beadchip.service';
import { MultiBeadChipUpdate } from '../ma-beadchip/multibeadchip-update-dto';
import { WorkFlow } from '../masterdata/models/workFlow';
import { MasterDataService } from '../masterdata/masterdata.service';
import { ActivatedRoute } from '@angular/router';
import { MultiCommentDTO } from '../ma-comments-popup/comment-dto';
import { Machine } from '../masterdata/models/machine';
import { BeadChipProcessFlows } from '../models/process-flows';
import { ProcessFlow } from '../masterdata/models/processFlow';
import { AnnouncedService } from '../apg-announced/services/announced.service';
import { PlateListDTO } from '../dto/plateListDTO';
import { formatDate } from '@angular/common';

@Component({
  selector: 'app-ma-beadchip',
  templateUrl: './ma-beadchip.component.html',
  styleUrls: ['./ma-beadchip.component.css']
})
export class MaBeadchipComponent implements OnInit {
  errorHandler: ErrorHandler = new ErrorHandler;
  loading: boolean;
  plates:Plate[];
  blocked = false;
  @Input() beadchips: BeadChip[];
  selectedBeadChip: BeadChip;
  beadchipPlates: Plate[];
  selectedBeadChipPlate: Plate;
  selectedBeadChipStepsMap: Map<string, Step>;
  puid: string;
  selectedLabId: string;
  beadChipFilterOptions: any[];
  plateWorkFlowList = [];
  workFlowData: WorkFlow[] = [];
  mapOfStatusSaves = new Map();
  mapOfProcessStepsFlow : Map<string, string[]> = new Map();
  mapOfProcessStepAndAction : Map<string, string[]> = new Map();
  mapOfActionRuntime : Map<string, number> = new Map();
  beadChipToSearch: string;
  sampleToSearch: string;

  previewComment: Comment;
  plateList:Plate[]=[];

  selectedBeadChipStatuses: string[] = [];
  selectedPlateWorkflows: string[] = [];
  beadChipFromDate: Date = new Date();

  showDialogue= false;

  processStep: string;
  noChemicalEdit : boolean;
  chemicalsBeadChipids: any[] = [];
  multiChemicalEdit: boolean;
  mapOfProcessStepsStatus = new Map();

  showCommentDialog : boolean = false;
  beadChipCommentsMap :Map<string, Comment[]> = new Map<string, Comment[]>();
  beadChipCommentsDisplayMap:Map<string, boolean> = new Map<string, boolean>();
  plateCommentsList: Comment[]=[];
  fetchedCommentsPlate : Plate;
  selectedPlateID : string ="";
  beadChipSelectedRow : boolean;

  selectedPlateStatus:string="";
  selectedPlate: Plate;
  selectedBeadchipStatus:string="";
  selectedBeadchip:BeadChip[];
  selectedProcessStep: string;
  processStepChemicals: any;

  showConfirmBeadChipsPopup = false;
  multiBeadChip = true;
  multiUpdateButtonStyleClass: string;
  multiUpdateInputLabel: string;
  multiUpdateStatusLabel: string;
  multiUpdateBeadChipList: Array<any>;
  enteredBeadChipId: string;
  fetchedBeadChipPlate: Plate;
  multiStage: number;
  multiStepName: string;
  multiActionName: string;
  multiActionPos: number;
  multiUpdateStatus : string;
  mapOfStatusAndLabel = new Map();
  multiBeadChipStepsMap: Map<string, Step> = new Map();
  multiBeadChipStepsMapList: Array<Map<string, Step>>;
  multiUpdateSelectedWorkFlow: string = "";

  lastUpdatedBeadChips1: any[] = []
  lastUpdatedBeadChips2: any[] = []
  lastUpdatedBeadChips3: any[] = []
  showMultipleCommentDialog = false;
  lastUpdatedStatus: string;
  newMultiComment: string = '';

  isFileNotSelected : boolean = true;
  uploadedFile : File;
  uploadedFileContent : any;
  @ViewChild('manualfileUpload')
  fileUploadElement: ElementRef;

  @Input() machinesList: Machine[];
  extensionLiquidHandler: string = '';
  multiLiquidHandler: string = '';
  multiBeadChipCompletePlateIds: boolean[] = [];
  multiBeadChipPlateIds: string[] = [];
  @Input() isBeadChipSelectedFromSamplesComponent: boolean = false;

  sampleTypeProcessFlowMap: Map<string, ProcessFlow> = new Map();
  workFlowMap: Map<string, WorkFlow> = new Map();
  processFlows: ProcessFlow[] = []
  selectedProcessFlow: string = "";
  workFlowList = [];
  beadChipViewSelected: boolean = false;
  @Input() scannedPlateID: string = null;
  tableSelectedRow: Plate;

  constructor( private platePreparationService: MaPlatePreparationService,private beadchipService : BeadchipService,
    private announcementService:AnnouncedService, private _messagesService:MessagesService, 
    private masterDataService: MasterDataService, private activatedRoute: ActivatedRoute) { }

  ngOnInit() {
    this.puid = localStorage.getItem("PUID");
    this.selectedLabId = JSON.parse(localStorage.getItem('lab')).lab._id;
    this.beadChipFilterOptions = [
      { label: 'Loaded', value: BeadChipStatus.LOADED},
      { label: 'Hybridization Started', value: BeadChipStatus.HYBRIDIZATION_STARTED },
      { label: 'Hybridization Completed', value: BeadChipStatus.HYBRIDIZATION_COMPLETED},
      { label: 'Washing Started', value: BeadChipStatus.WASHING_STARTED },
      { label: 'Washing Completed', value: BeadChipStatus.WASHING_COMPLETED },
      { label: 'Extension Started' , value: BeadChipStatus.EXTENSION_STARTED},
      { label: 'Extension Completed' , value: BeadChipStatus.EXTENSION_COMPLETED},
      { label: 'Coating Started' , value: BeadChipStatus.COATING_STARTED},
      { label: 'Coating Completed' , value: BeadChipStatus.COATING_COMPLETED},
      { label: 'BeadChip Imaged' , value: BeadChipStatus.BEADCHIP_IMAGED},
      { label: 'Completed' , value: BeadChipStatus.COMPLETED},
    ];
    this.beadChipFromDate.setDate( new Date().getDate() - 5) 
    this.fetchBeadchips(undefined, undefined, this.beadChipFromDate);
    this.getAllActiveWorkFlowList();
    this.selectedBeadChipPlate = new Plate();
    this.selectedBeadChipStepsMap = new Map();

    this.mapOfStatusSaves.set(BeadChipStatus.WASHING_STARTED, "startWashing");
    this.mapOfStatusSaves.set(BeadChipStatus.WASHING_COMPLETED, "completeWashing")
    this.mapOfStatusSaves.set(BeadChipStatus.EXTENSION_STARTED, "startExtension")
    this.mapOfStatusSaves.set(BeadChipStatus.EXTENSION_COMPLETED, "completeExtension")
    this.mapOfStatusSaves.set(BeadChipStatus.COATING_STARTED, "startCoating")
    this.mapOfStatusSaves.set(BeadChipStatus.COATING_COMPLETED, "completeCoating")
    this.mapOfStatusSaves.set(BeadChipStatus.BEADCHIP_IMAGED, "imageBeadchip")
    this.mapOfStatusSaves.set(BeadChipStatus.COMPLETED, "sendResultFiles")
    this.mapOfStatusSaves.set(BeadChipAction.BEADCHIP_DRYING, "actionBeadchipDrying");

    this.mapOfProcessStepsFlow.set(BeadChipProcessStep.WASHING, [BeadChipProcessStep.LOADING])
    this.mapOfProcessStepsFlow.set(BeadChipProcessStep.EXTENSION, [BeadChipProcessStep.WASHING])
    this.mapOfProcessStepsFlow.set(BeadChipProcessStep.COATING, [BeadChipProcessStep.EXTENSION])
    this.mapOfProcessStepsFlow.set(BeadChipProcessStep.COMPLETED, [BeadChipProcessStep.COATING])

    this.mapOfProcessStepAndAction.set(BeadChipProcessStep.COATING, [BeadChipAction.BEADCHIP_DRYING])

    this.mapOfActionRuntime.set(BeadChipAction.BEADCHIP_DRYING, 60)

    this.mapOfProcessStepsStatus.set(BeadChipStatus.LOADED,[]);
    this.mapOfProcessStepsStatus.set(BeadChipStatus.HYBRIDIZATION_STARTED, []);
    this.mapOfProcessStepsStatus.set(BeadChipStatus.HYBRIDIZATION_COMPLETED, []);
    this.mapOfProcessStepsStatus.set(BeadChipStatus.WASHING_STARTED,[BeadChipProcessStep.WASHING]);
    this.mapOfProcessStepsStatus.set(BeadChipStatus.WASHING_COMPLETED,[]);
    this.mapOfProcessStepsStatus.set(BeadChipStatus.EXTENSION_STARTED,[BeadChipProcessStep.EXTENSION]);
    this.mapOfProcessStepsStatus.set(BeadChipStatus.EXTENSION_COMPLETED,[]);
    this.mapOfProcessStepsStatus.set(BeadChipStatus.COATING_STARTED,[BeadChipProcessStep.COATING]);
    this.mapOfProcessStepsStatus.set(BeadChipStatus.COATING_COMPLETED,[]);
    this.mapOfProcessStepsStatus.set(BeadChipStatus.RESULT_FILE_SENT,[]);
    this.mapOfProcessStepsStatus.set(BeadChipStatus.BEADCHIP_IMAGED, []);
    this.mapOfProcessStepsStatus.set(BeadChipStatus.COMPLETED,[]);

    this.multiUpdateButtonStyleClass= "";
    this.multiUpdateInputLabel= "";
    this.multiUpdateStatusLabel= "";
    this.multiUpdateBeadChipList= [];
    this.enteredBeadChipId= "";
    this.multiBeadChipStepsMapList = new Array();
    
    this.mapOfStatusAndLabel.set(BeadChipStatus.WASHING_STARTED, "Start Washing")
    this.mapOfStatusAndLabel.set(BeadChipStatus.WASHING_COMPLETED, "Complete Washing")
    this.mapOfStatusAndLabel.set(BeadChipStatus.EXTENSION_STARTED, "Start Extension")
    this.mapOfStatusAndLabel.set(BeadChipStatus.EXTENSION_COMPLETED, "Complete Extension")
    this.mapOfStatusAndLabel.set(BeadChipStatus.COATING_STARTED, "Start Coating")
    this.mapOfStatusAndLabel.set(BeadChipAction.IMAGE_BEADCHIP, "Image Beadchip")
    this.mapOfStatusAndLabel.set(BeadChipStatus.COATING_COMPLETED, "Complete Coating")
    this.mapOfStatusAndLabel.set(BeadChipStatus.COMPLETED, "Resultfiles Sent")
    this.mapOfStatusAndLabel.set(BeadChipStatus.BEADCHIP_IMAGED, "Image Beadchip")
    this.mapOfStatusAndLabel.set(BeadChipAction.BEADCHIP_DRYING, "Beadchip Drying")

    this.selectedProcessFlow = BeadChipProcessFlows.OLD_FLOW
    this.getAllWorkFlowList()
    this.getAllProcessFlows();
    //hardcoding preview comment - to be removed
    this.previewComment = new Comment();
    
    this.activatedRoute.queryParams.subscribe(params=>{
      var beadchipID: string = params['beadchipID']
      if(beadchipID && beadchipID.trim()!==''){
        this.beadChipToSearch = beadchipID;
        this.searchForBeadChip()
      }
    });

    if(this.scannedPlateID) {
      this.beadChipToSearch = this.scannedPlateID;
      this.searchForBeadChip();
      this.scannedPlateID = null;
    }
  }

  ngOnChanges() {
    this.ngOnInit();
  }

  getAllProcessFlows() {
    this.sampleTypeProcessFlowMap.clear();
    this.blocked = true;
    this.masterDataService.getConfigList(this.selectedLabId, 'processFlow', 0, 100, true).subscribe(results => {
      this.blocked = false;
      if(results && results.data){
        this.processFlows = results.data;
        this.processFlows.forEach(p => {
          this.sampleTypeProcessFlowMap.set(p.processFlowName, p);
        })
      }
    }, error => {
      this.blocked = false;
      this.showError(error);
    })
  }

  toggleBeadChipView(){
    if(this.selectedBeadChipPlate && this.selectedBeadChipPlate.plateID){
      this.beadChipViewSelected = !this.beadChipViewSelected
    }
  }

  saveBeadchipStatus(status: string,stage: number, stepName: string, actionName: string, actionPos: number){
    if(this.multiBeadChip){
      this.multiStage = stage;
      this.multiActionName = actionName;
      this.multiActionPos =  actionPos;
      this.multiStepName = stepName;
      this.multiUpdateStatus = status;
      this.multiUpdateStatusLabel = this.mapOfStatusAndLabel.has(status) ? this.mapOfStatusAndLabel.get(status) : status;
      if(status == BeadChipStatus.COMPLETED){
        this.multiUpdateButtonStyleClass = 'completeButton'
      }
      else if(status == BeadChipStatus.BEADCHIP_IMAGED){
          this.multiUpdateButtonStyleClass = "actionButton"
      }
      else{
        if(stage==ProcessStepStage.start){
          this.multiUpdateButtonStyleClass = "startButton"
        }else if(stage==ProcessStepStage.end){
          this.multiUpdateButtonStyleClass = "endButton"
        }else{
          this.multiUpdateButtonStyleClass = "actionButton"
        }
      }
      if(BeadChipStatus.EXTENSION_STARTED == status)
        this.multiLiquidHandler = this.extensionLiquidHandler;
      else
        this.multiLiquidHandler = '';

      this.enteredBeadChipId ="";
      this.multiUpdateBeadChipList = [];
      this.multiBeadChipCompletePlateIds = [];
      this.multiBeadChipPlateIds = [];
      this.multiUpdateInputLabel = "Scan BeadChip"
      setTimeout(()=>{
        this.findAndHighlightElement("popup-beadchipid")
      }, 10)
      
      this.showConfirmBeadChipsPopup = true;
    }
    else{
      let funtionName = this.mapOfStatusSaves.get(status);
      this[funtionName](status);
    }
  }

  startWashing(status: string){
    if(!this.updateProcessStep(BeadChipProcessStep.WASHING, ProcessStepStage.start, "")){
      return;
    }
    this.selectedBeadChipPlate.status = status;
    this.updateBeadChip();
  }

  completeWashing(status: string){
    if(!this.updateProcessStep(BeadChipProcessStep.WASHING, ProcessStepStage.end, "")){
      return;
    }
    this.selectedBeadChipPlate.status = status;
    this.updateBeadChip();
  }

  startExtension(status: string){
    if(!this.updateProcessStep(BeadChipProcessStep.EXTENSION, ProcessStepStage.start, "", this.extensionLiquidHandler)){
      return;
    }
    this.selectedBeadChipPlate.status = status;
    this.updateBeadChip(this.extensionLiquidHandler, BeadChipProcessStep.EXTENSION);
  }

  completeExtension(status: string){
    if(!this.updateProcessStep(BeadChipProcessStep.EXTENSION, ProcessStepStage.end, "")){
      return;
    }
    this.selectedBeadChipPlate.status = status;
    this.updateBeadChip();
  }

  startCoating(status: string){
    if(!this.updateProcessStep(BeadChipProcessStep.COATING, ProcessStepStage.start, "")){
      return;
    }
    this.selectedBeadChipPlate.status = status;
    this.updateBeadChip();
  }

  completeCoating(status: string){
    if(!this.updateProcessStep(BeadChipProcessStep.COATING, ProcessStepStage.end, "")){
      return;
    }
    this.selectedBeadChipPlate.status = status;
    this.updateBeadChip();
  }

  sendResultFiles(status: string){
    if(!this.updateProcessStep(BeadChipProcessStep.COMPLETED, ProcessStepStage.end, "")){
      return;
    }
    this.selectedBeadChipPlate.status = status;
    this.updateBeadChip();
  }

  imageBeadchip(status: string){
    if(!this.updateProcessStep(BeadChipProcessStep.COMPLETED, ProcessStepStage.start, "")){
      return;
    }
    this.showWarningMessage(BeadChipProcessStep.COATING, BeadChipAction.BEADCHIP_DRYING);
    this.selectedBeadChipPlate.status = status;
    this.updateBeadChip();
  }

  actionBeadchipDrying(status: string){
    if(!this.updateProcessStep(BeadChipProcessStep.COATING, ProcessStepStage.action, BeadChipAction.BEADCHIP_DRYING)){
      return;
    }
    this.updateBeadChip();
  }

  updateMultiBeadChips(){
    if(!this.isPUIDPresent()){
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: 'USER ID not present!',
        detail: 'Please  enter USER ID before moving ahead',
      });
      return;
    }
    switch(this.multiStage){
      case ProcessStepStage.start:
        this.updateStartProcessForMultipleBeadChips()
        break;
      case ProcessStepStage.end:
        this.updateEndProcessorForMultipleBeadChips();
        break;
      case ProcessStepStage.action:
        this.updateStartActionProcessorForMultipleBeadChips();
        break;
    }
  }

  updateStartActionProcessorForMultipleBeadChips() {
    let multiUpdateDto = this.getMultiUpdateDto();
    this.platePreparationService.updateStartActionProcessForMultiplePlates(multiUpdateDto).subscribe(
      (result) => {
        this._messagesService.addSuccessMessage({severity: 'success', summary: 'Success', detail: result})
        this.lastUpdatedStatus = multiUpdateDto.status;
        this.updateLastUpdatedBeadChips();        
        this.closeMultiUpdatePopup();
        this.multiBeadChip = true;
      },
      (error) =>{
        this._messagesService.addErrorMessage({ severity: 'error', summary: 'Error', detail: error.error })
      }
    )
  }

  updateEndProcessorForMultipleBeadChips() {
    let multiUpdateDto = this.getMultiUpdateDto();
    this.platePreparationService.updateEndProcessForMultiplePlates(multiUpdateDto).subscribe(
      (result)=>{
        this._messagesService.addSuccessMessage({ severity: 'success', summary: 'Success', detail: result });
        this.lastUpdatedStatus = multiUpdateDto.status;
        this.updateLastUpdatedBeadChips();        
        this.closeMultiUpdatePopup();
        this.multiBeadChip = true;
      },
      (error) =>{
        this._messagesService.addErrorMessage({ severity: 'error', summary: 'Error', detail: error.error })
      }
    )
  }
  
  updateStartProcessForMultipleBeadChips() {
    let multiUpdateDto = this.getMultiUpdateDto();
    this.platePreparationService.updateStartProcessForMultiplePlates(multiUpdateDto).subscribe(
      (result) =>{
        this._messagesService.addSuccessMessage({ severity: 'success', summary: 'Success', detail: result })
        this.lastUpdatedStatus = multiUpdateDto.status;
        this.updateLastUpdatedBeadChips();        
        this.closeMultiUpdatePopup();
        this.multiBeadChip = true;
        if(BeadChipStatus.EXTENSION_STARTED === multiUpdateDto.status)
          this.updateMachine(multiUpdateDto.liquidHandler, BeadChipProcessStep.EXTENSION, this.multiUpdateSelectedWorkFlow);
        this.multiUpdateSelectedWorkFlow = "";
      },
      (error) =>{
        this._messagesService.addErrorMessage({ severity: 'error', summary: 'Error', detail: error.error })
      }
    )
  }

  getMultiUpdateDto(): any {
    let multiBeadChipUpdate : MultiBeadChipUpdate = new MultiBeadChipUpdate();
    multiBeadChipUpdate.action = this.multiActionName;
    multiBeadChipUpdate.plateids = this.multiUpdateBeadChipList;
    multiBeadChipUpdate.step = this.multiStepName;
    multiBeadChipUpdate.labid = this.selectedLabId;
    multiBeadChipUpdate.puid = this.puid;
    multiBeadChipUpdate.liquidHandler = this.multiLiquidHandler;
    multiBeadChipUpdate.status = this.multiUpdateStatus;
    multiBeadChipUpdate.actionRunTime = this.mapOfActionRuntime.get(this.multiActionName);
    multiBeadChipUpdate.sourceplateids = this.multiBeadChipPlateIds;
    multiBeadChipUpdate.completeplateids = this.multiBeadChipCompletePlateIds;
    return multiBeadChipUpdate;
  }
  
  resetLastUpdatedBeadChips(){
    this.lastUpdatedBeadChips1 = [];
    this.lastUpdatedBeadChips2 = [];
    this.lastUpdatedBeadChips3 = [];
    this.chemicalsBeadChipids = [];
  }

  updateLastUpdatedBeadChips(){
    this.lastUpdatedBeadChips1 = [];
    this.lastUpdatedBeadChips2 = [];
    this.lastUpdatedBeadChips3 = [];
    this.chemicalsBeadChipids = [];
    
    for(var i=0;i<30;i++){
      var updatedBeadChip = { BeadChipId : this.multiUpdateBeadChipList.length>i ? this.multiUpdateBeadChipList[i] : '' }
      if(i<10){
        this.lastUpdatedBeadChips1.push(updatedBeadChip)
      }else if(i<20){
        this.lastUpdatedBeadChips2.push(updatedBeadChip)
      }else{
        this.lastUpdatedBeadChips3.push(updatedBeadChip)
      }
      if(this.multiUpdateBeadChipList.length>i)
        this.chemicalsBeadChipids.push(this.multiUpdateBeadChipList[i]);
    }
    
  }

  closeMultiUpdatePopup() {
    this.showConfirmBeadChipsPopup = false;
    this.multiUpdateBeadChipList = [];
    this.enteredBeadChipId = "";
    this.multiBeadChipStepsMap.clear();
    this.multiBeadChipStepsMapList = [];
    this.selectedBeadChipPlate = new Plate();
    this.multiBeadChipCompletePlateIds = [];
    this.multiBeadChipPlateIds = [];
    this.onApplyBeadChipFilter()
  }

  deleteBeadChipFromMultiUpdateList(index: number){
    this.multiUpdateBeadChipList.splice(index,1);
    this.multiBeadChipCompletePlateIds.splice(index,1);
    this.multiBeadChipPlateIds.splice(index,1);
    this.findAndHighlightElement('popup-beadchipid');
  }

  checkBeadChip(){
    if(this.enteredBeadChipId && this.multiUpdateBeadChipList && this.multiUpdateBeadChipList.includes(this.enteredBeadChipId)) {
      this._messagesService.addWarningMessage({ severity: 'warn', summary: 'Duplicate BeadChip', detail: 'BeadChip already Scanned.' });
      this.enteredBeadChipId = "";
      return;
    }
    if(this.enteredBeadChipId && this.multiUpdateBeadChipList && this.multiUpdateBeadChipList.length>20) {
      this._messagesService.addWarningMessage({ severity: 'warn', summary: 'Max BeadChips Reached', detail: '20 BeadChips already Scanned.' });
      this.enteredBeadChipId = "";
      return;
    }
    if(this.enteredBeadChipId && this.enteredBeadChipId =="") {
      this._messagesService.addWarningMessage({ severity: 'warn', summary: 'Empty BeadChip', detail: 'Please scan a BeadChip.' });
      return;
    }
    this.fetchedBeadChipPlate = null;
    if(this.multiStage == 1 && this.multiStepName == BeadChipProcessStep.COMPLETED){
      this.platePreparationService.fetchPlate(this.enteredBeadChipId, this.selectedLabId).subscribe(
        (result) => {
          this.fetchedBeadChipPlate = result;
          this.prepareProcessStepMapforMultiBeadChipUpdate();
          let notEligible = this.eligibleBeadChip(this.multiStage, this.multiStepName, this.multiActionName, this.multiActionPos);
          if(notEligible){
            this._messagesService.addWarningMessage({ severity: 'warn', summary: 'BeadChip Not eligible', detail: 'Please scan a diffrent BeadChip.' });
            this.enteredBeadChipId = "";
          } 
          else{
            this.multiUpdateBeadChipList.push(this.enteredBeadChipId);
            this.enteredBeadChipId ="";
            this.multiUpdateSelectedWorkFlow = this.fetchedBeadChipPlate.workFlow;
            if(this.fetchedBeadChipPlate.sourcePlates) 
              this.fetchedBeadChipPlate.sourcePlates.forEach(s => this.multiBeadChipPlateIds.push(s.plateID));
            if(this.fetchedBeadChipPlate.status != 'COMPLETED')
              this.multiBeadChipCompletePlateIds.push(false);
            else
              this.multiBeadChipCompletePlateIds.push(true);
          }
        }, (error) => {
          this._messagesService.addErrorMessage({
            severity: 'error', summary: 'Failed to fetch beadchip info',
            detail: error.error.error
          })
        }
      )
    }
    else{
      this.platePreparationService.processDetailsbyPlateId(this.selectedLabId, this.enteredBeadChipId, "SOURCE").subscribe(
        result => {
          this.fetchedBeadChipPlate = result;
          this.prepareProcessStepMapforMultiBeadChipUpdate();
          let notEligible = this.eligibleBeadChip(this.multiStage, this.multiStepName, this.multiActionName, this.multiActionPos);
          if(notEligible){
            this._messagesService.addWarningMessage({severity: 'warn', summary: 'Invalid', detail: 'Beadchip '+this.enteredBeadChipId+ ' is not eligible to perform this process step'});
            this.enteredBeadChipId = "";
          }else{
            this.multiUpdateBeadChipList.push(this.enteredBeadChipId);
            this.enteredBeadChipId = "";
            this.multiUpdateSelectedWorkFlow = this.fetchedBeadChipPlate.workFlow;
          }
        },(_error)=>{
            this._messagesService.addErrorMessage({
              severity: "error", summary: "Plate not found!",
              detail: "Plate not found with plate id - " + this.enteredBeadChipId
            })
          this.enteredBeadChipId = "";
        }
      )
    }
  }
  
  prepareProcessStepMapforMultiBeadChipUpdate() {
    this.multiBeadChipStepsMap = new Map();
    if(!this.fetchedBeadChipPlate.processSteps || this.fetchedBeadChipPlate.processSteps==null)
      return;
    this.fetchedBeadChipPlate.processSteps.forEach(step => {
      step.actionMap = new Map();
      step.action.forEach(s => {
        step.actionMap.set(s.action, s);
      })
      this.multiBeadChipStepsMap.set(step.step, step);
    });
    this.multiBeadChipStepsMapList.push(this.multiBeadChipStepsMap);
  }

  eligibleBeadChip(stage: number, stepName: string, actionName: string, actionPos: number){
    if((!this.multiBeadChipStepsMap || this.multiBeadChipStepsMap==null || this.multiBeadChipStepsMap.size < 1)){
      return true;
    }
    switch(stage){
      case ProcessStepStage.start:
        return this.disableProcessStepStart(stepName, this.multiBeadChipStepsMap);
      case ProcessStepStage.end:
        return this.disableProcessStepEnd(stepName, this.multiBeadChipStepsMap);
      case ProcessStepStage.action:
        return this.disableProcessStepAction(stepName, actionName, actionPos, this.multiBeadChipStepsMap);
      default:
        return true;
    }
  }

  findAndHighlightElement(elementId){
    let element = document.getElementById(elementId);
    if(element){
      element.focus();
    }
  }

  isPUIDPresent() {
    if (this.puid != null && this.puid != undefined && this.puid != '') {
      return true;
    }
    return false;
  }

  updateBeadChip(liquidHandler: string = "", processStep: string = "") {
    if(!this.isPUIDPresent()){
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: 'USER ID not present!',
        detail: 'Please enter USER ID before moving ahead',
      });
      return;
    }
    this.selectedBeadChipPlate.processSteps.forEach(step => step.actionMap=undefined)
    let selectedWorkFlow = this.selectedBeadChipPlate.workFlow;
    let completePlate:boolean = false;
    let puid = this.puid;
    if(this.selectedBeadChipPlate.status == 'COMPLETED'){
      completePlate = true;
    }
    this.platePreparationService.updatePlate(this.selectedBeadChipPlate.plateID, this.selectedBeadChipPlate, this.selectedLabId).subscribe({
      next : (result) => {
        this.selectedBeadChipPlate = result;
        this.onApplyBeadChipFilter();
        this.prepareProcessStepsMap();
        this._messagesService.addSuccessMessage({
          severity: 'success', summary: 'Beadchip '+this.selectedBeadChipPlate.plateID+' is updated',
          detail: this.selectedBeadChipPlate.plateID+' has been updated successfully with requested status'
        })
        if(liquidHandler != "" && processStep!="" && BeadChipProcessStep.EXTENSION === processStep)
          this.updateMachine(liquidHandler, processStep, selectedWorkFlow);
        liquidHandler = "";
        processStep = "";
      }, error: (error: any) => {
        this._messagesService.addErrorMessage({
          severity: 'error', summary: 'Failed',
          detail: error.error.error
        })
      }
    })
  }

  updateProcessStep(step: string, stage: ProcessStepStage, actionName: string, liquidHandler: string = ""): boolean{
    if(this.selectedBeadChipStepsMap.has(step)){
      var existingStep = this.selectedBeadChipPlate.processSteps.find(s => s.step == step);
      if(ProcessStepStage.start==stage){
        existingStep.startTimeStamp = new Date();
        existingStep.startPUID = this.puid;
        existingStep.liquidHandler = liquidHandler;
      }else if(ProcessStepStage.end==stage){
        existingStep.endTimeStamp = new Date();
        existingStep.endPUID = this.puid;
      }else{
        if(existingStep.actionMap.has(actionName)){
          var existingAction = existingStep.action.find(a => a.action == actionName);
          existingAction.actionPUID = this.puid;
          existingAction.actionStartTime = new Date();
        }else{
          existingStep.action = (!existingStep.action || existingStep.action==null) ? [] : existingStep.action;
          var newAction = new StepAction();
          newAction.action = actionName;
          newAction.actionPUID = this.puid;
          newAction.actionStartTime = new Date();
          newAction.actionRunTime = this.mapOfActionRuntime.get(actionName)
          existingStep.action.push(newAction);
        }
      }
    }else{
      this.selectedBeadChipPlate.processSteps = (!this.selectedBeadChipPlate.processSteps || this.selectedBeadChipPlate.processSteps==null) ? [] : this.selectedBeadChipPlate.processSteps;
      var newStep = new Step();
      newStep.step = step;
      if(ProcessStepStage.start==stage){
        newStep.startTimeStamp = new Date();
        newStep.startPUID = this.puid;
        newStep.liquidHandler = liquidHandler;
        //server is forcing to put default/dummy values, otherwise it is throwing 500
        newStep.endPUID = "";
        newStep.endTimeStamp = null;
      }else{
        this._messagesService.addWarningMessage({
          severity: 'warn', summary: 'Action not allowed',
          detail: 'Process has to be started to perform this action'
        })
        return false;
      }
      //temp: hardcoding defaults to avoid server 500
      newStep.action = [];
      newStep.chemicals = [];
      this.selectedBeadChipPlate.processSteps.push(newStep)
    }
    return true;
  }

  searchForBeadChip() {
    if(!this.beadChipToSearch || this.beadChipToSearch===''){
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: 'Please enter a BatchID',
        detail: 'Batch ID cannot be empty, please enter something to search'
      })
      return;
    }
    this.multiBeadChip = false;
    this.multiChemicalEdit = false;
    this.searchForBeadChipAction(this.beadChipToSearch);
  }

  searchForSample() {
    if(!this.sampleToSearch && this.sampleToSearch===''){
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: 'Enter sample ID to search',
        detail: 'Please enter something to search'
      })
      return;
    }
    this.blocked = true
    this.announcementService.getSampleFromDelivery(this.selectedLabId,this.sampleToSearch).subscribe({ next : (result) => {
      let sample = result.data[0]
      let sample_id = sample['_id']
      this.platePreparationService.fetchPlateBySample(sample_id, this.selectedLabId, "BEADCHIP").subscribe(
        (result)=>{
        this.blocked = false
          this._messagesService.addSuccessMessage({
            severity: 'success', detail: 'Sample search success!'
          })
          this.selectedBeadChipPlate = result;
          this.prepareProcessStepsMap();
        },
        (error)=>{
          console.log(error)
          this._messagesService.addErrorMessage({
            severity:"error",summary:"Plate not found!",
            detail:"Plate not found with sample "+this.sampleToSearch
          })
        }
      )
    },
    error: (error: any) => {
      console.log(error)
      this._messagesService.addErrorMessage({
        severity:"error",summary:"Plate not found!",
        detail:"Plate not found with sample "+this.sampleToSearch
      })
    }})
  }

  getAllWorkFlowList() {
    this.blocked = true;
    this.masterDataService.getAllActiveWorkFlow(this.selectedLabId).subscribe(results => {
      if (results && results.data) {
        this.workFlowData = results.data;
        this.workFlowList = [];
        this.workFlowData.forEach(e => {
          this.workFlowList.push({ label: e.workFlowName, value: e.workFlowName });
          this.workFlowMap.set(e.workFlowName, e);
        });
        this.blocked = false;
      }
    },
      (error: any) => {
        this.blocked = false;
        this.showError(error);
      });
  }

  getAllActiveWorkFlowList() {
    this.loading = true;
    this.masterDataService.getAllActiveWorkFlow(this.selectedLabId).subscribe(results => {
      if (results && results.data) {
        this.workFlowData = results.data;
        this.plateWorkFlowList = [];
        this.workFlowData.forEach(e => {
          this.plateWorkFlowList.push({ label: e.workFlowName, value: e.workFlowName });
        });
        this.loading = false;
      }
    },
      (error: any) => {
        this.loading = false;
        this.showError(error);
      });

  }

  onApplyBeadChipFilter(){
    this.fetchBeadchips(this.selectedBeadChipStatuses, this.selectedPlateWorkflows, this.beadChipFromDate);
  }

  showError(error: any) {
    let message = error.error;
    this._messagesService.addErrorMessage(message);
  }

  showWarningMessage(stepName:string,actionName:string){
    let actionStartTime: Date = this.getProcessStepActionTimeStamp(stepName, actionName);
    let actionRunTime: number = this.selectedBeadChipStepsMap.get(stepName).actionMap.get(actionName).actionRunTime;
     if(this.calculatingTimes(this.calculateRemainingTime(actionRunTime, actionStartTime))>"00:00:00"){
      this._messagesService.addWarningMessage({
              severity: 'warn', summary: 'Timer is not at ZERO!',
              detail: "The time for action button is still running!",
            });
          }
  }

  calculatingTimes(timeLeftInSecs: number) {
    let timeLeft = Math.floor(timeLeftInSecs);
    if (timeLeft == 0)
      return "00:00:00";
    let sec = 0, min = 0, hr = 0
    if (timeLeft % 60 != 0) {
      sec = timeLeft % 60;
      timeLeft = timeLeft - sec;
    }
    timeLeft = timeLeft / 60;
    if (timeLeft % 60 != 0) {
      min = timeLeft % 60;
      timeLeft = timeLeft - min;
    }
    timeLeft = timeLeft / 60;
    hr = timeLeft;
    let secStr = "00" + sec, minStr = "00" + min, hrStr = "00" + hr
    return hrStr.substring(hrStr.length - 2) + ':' + minStr.substring(minStr.length - 2) + ":" + secStr.substring(secStr.length - 2);
  }

  fetchBeadchip(event) {
    this.beadChipViewSelected = false
    this.multiBeadChip = false;
    this.multiChemicalEdit = false;
    this.resetLastUpdatedBeadChips()
    this.searchForBeadChipAction(event.data.plateID);
  }

  searchForBeadChipAction(beadChipId: string){
    this.platePreparationService.fetchPlate(beadChipId, this.selectedLabId).subscribe(
      result => {
        this.selectedBeadChipPlate = result;
        this.findProcessFlow(this.selectedBeadChipPlate.workFlow);
        this.prepareProcessStepsMap();
      }, (error) => {
        this._messagesService.addErrorMessage({
          severity: 'error', summary: 'Failed to fetch beadchip info',
          detail: error.error.error
        })
      }
    )
  }

  findProcessFlow(workFlow){
    if(workFlow && this.workFlowMap.has(workFlow) 
        && this.workFlowMap.get(workFlow).processFlow){
      var processFlowConfig : ProcessFlow = this.sampleTypeProcessFlowMap.get(this.workFlowMap.get(workFlow).processFlow[0])
      if(processFlowConfig && processFlowConfig.beadChipSize==384 && processFlowConfig.axiom384Propel){
        this.selectedProcessFlow = BeadChipProcessFlows.AXIOM_384;
      }else if(processFlowConfig && processFlowConfig.beadChipSize==48 && processFlowConfig.illuminaExInfinium && processFlowConfig.manualPost){
        this.selectedProcessFlow = BeadChipProcessFlows.OLD_FLOW
      }else{
        this.selectedProcessFlow = undefined;
        this._messagesService.addWarningMessage({
          severity: 'warn', summary: 'Invalid process flow',
          detail: 'Scanned/Selected plate might not get this processes, please try a different plate'
        })
      }
    }else{
      this.selectedProcessFlow = BeadChipProcessFlows.OLD_FLOW
    }
  }

  prepareProcessStepsMap() {
    this.selectedBeadChipStepsMap.clear();
    this.selectedBeadChipPlate.processSteps.forEach(step => {
      step.actionMap = new Map();
      step.action.forEach(s => {
        step.actionMap.set(s.action, s);
      })
      this.selectedBeadChipStepsMap.set(step.step, step);
    })
  }

  resetAllBeadChipFilter(){
    this.selectedBeadChipStatuses = [];
    this.selectedPlateWorkflows = [];
    this.beadChipFromDate = undefined;
    this.fetchBeadchips();
  }

  checkBeadChipTabActive(){
    if(this.isBeadChipSelectedFromSamplesComponent){
      this.isBeadChipSelectedFromSamplesComponent = false;
      this.onApplyBeadChipFilter()
    }
    return true;
  }

  preparePlateSearchDTO(labId: string, type?: string, status?: string, processFlowName?: string, fromDate?: Date): PlateListDTO {
    const plateListDTO = new PlateListDTO();
    plateListDTO.labId = labId;
    if (typeof type !== 'undefined') {
      plateListDTO.type = type;
    }
    if (typeof status !== 'undefined') {
      plateListDTO.status = status;
    }
    if (typeof processFlowName !== 'undefined') {
      plateListDTO.processFlowName = processFlowName;
    }
    if (fromDate !== undefined && fromDate !== null) {
      plateListDTO.fromDate = formatDate(fromDate, 'yyyy-MM-dd', 'en-US');
    }
    return plateListDTO;
  }

  fetchBeadchips(status?:string[], workflow?: string[], fromDate?: Date) {
    this.loading = true;
    if (status === undefined || status.length === 0)
    status = [BeadChipStatus.LOADED, BeadChipStatus.HYBRIDIZATION_STARTED, BeadChipStatus.HYBRIDIZATION_COMPLETED, BeadChipStatus.WASHING_STARTED, 
      BeadChipStatus.WASHING_COMPLETED, BeadChipStatus.CHAMBER_ASSEMBLED, BeadChipStatus.CHAMBER_RACK_SETUP, BeadChipStatus.EXTENSION_STARTED,
      BeadChipStatus.EXTENSION_COMPLETED, BeadChipStatus.COATING_STARTED, BeadChipStatus.COATING_COMPLETED, BeadChipStatus.RESULT_FILE_SENT, BeadChipStatus.BEADCHIP_IMAGED, BeadChipStatus.COMPLETED, BeadChipStatus.GENE_TITAN_PREP_STARTED, BeadChipStatus.GENE_TITAN_PREP_COMPLETED, BeadChipStatus.GENE_TITAN_LOADED]
    if (workflow === undefined || workflow.length === 0)
      workflow = undefined
    this.platePreparationService.fetchPlates(this.preparePlateSearchDTO(this.selectedLabId, "BEADCHIP", status.join(','), undefined, fromDate)).subscribe({
      next : (result) => {
        this.loading = false;
        this.beadchipPlates = result;
        if(this.selectedPlate.plateID != null){
          for(let i=0; i<this.beadchipPlates.length; i++){
            if(this.selectedPlate.plateID == this.beadchipPlates[i].plateID){
              this.tableSelectedRow = this.beadchipPlates[i]
            }
          }
        }
      }, error: (error: any) => {
        this.loading = false;
        this._messagesService.addErrorMessage({
          severity: 'error', summary: 'Failed to fetch beadchips',
          detail: 'Some issue in pulling the beadchips, please try again'
        })
      }
    })
  }

  disableButton(stage: number, stepName: string, actionName: string, actionPos: number): boolean{
    if(this.multiBeadChip){
      return false;
    }
    switch(stage){
      case ProcessStepStage.start:
        return this.disableProcessStepStart(stepName,this.selectedBeadChipStepsMap);
      case ProcessStepStage.end:
        return this.disableProcessStepEnd(stepName,this.selectedBeadChipStepsMap);
      case ProcessStepStage.action:
        return this.disableProcessStepAction(stepName, actionName, actionPos,this.selectedBeadChipStepsMap);
      default:
        return true;
    }
  }

  disableProcessStepStart(stepName: string, selectedBeachipStepsMap:Map<string, Step>): boolean {
    let dependentSteps: string[] = this.mapOfProcessStepsFlow.get(stepName);
    let disable: boolean = true;
    for(let step of dependentSteps){
      if(step==BeadChipProcessStep.LOADING || step==BeadChipProcessStep.ASSEMBLING_CHAMBER || step==BeadChipProcessStep.CHAMBER_RACK_SETUP){
        disable = !selectedBeachipStepsMap.has(step) || this.isEmptyString(selectedBeachipStepsMap.get(step).startPUID) || this.isEmptyDate(selectedBeachipStepsMap.get(step).startTimeStamp);
        break;
      }
      let dependentProcessStep = selectedBeachipStepsMap.get(step);
      if(step == BeadChipProcessStep.COATING && dependentProcessStep != undefined){
        disable = !dependentProcessStep || this.isEmptyString(dependentProcessStep.startPUID) || this.isEmptyDate(dependentProcessStep.startTimeStamp) || !dependentProcessStep.actionMap.has(BeadChipAction.BEADCHIP_DRYING)
        break;
      }
      if(dependentProcessStep && !this.isEmptyString(dependentProcessStep.endPUID) && !this.isEmptyDate(dependentProcessStep.endTimeStamp)){
        disable = false;
      }else{
        disable = true;
        break;
      }
    }
    if(selectedBeachipStepsMap.has(stepName)){
      disable = true;
    }
    return disable;
  }

  disableProcessStepAction(stepName: string, actionName: string, actionPos: number, selectedBeadchipStepsMap:Map<string, Step>): boolean{
    if(!selectedBeadchipStepsMap.has(stepName)){
      return true;
    }
    let disable: boolean = true;
    let currentProcessStep = selectedBeadchipStepsMap.get(stepName);
    if(actionName == BeadChipAction.BEADCHIP_DRYING && currentProcessStep != undefined){
        if(currentProcessStep.endPUID != "" && currentProcessStep.endTimeStamp != null){
          disable = false;
          if(currentProcessStep.actionMap.has(actionName))
            disable = true;
        }
    }
    else
      disable = currentProcessStep.actionMap.has(actionName);
    return disable;
  }

  disableProcessStepEnd(stepName: string, selectedBeadchipStepsMap:Map<string, Step>): boolean {
    if(!selectedBeadchipStepsMap.has(stepName)){
      return true;
    }
    let disable: boolean = false;
    let processStepActions : string[] = this.mapOfProcessStepAndAction.get(stepName);
    let currentProcessStep = selectedBeadchipStepsMap.get(stepName);   
    if(!this.isEmptyString(currentProcessStep.endPUID) && this.isEmptyDate(currentProcessStep.endTimeStamp)){
      disable = true
      return disable
    }
    if(!this.isEmptyString(currentProcessStep.endPUID) && !this.isEmptyDate(currentProcessStep.endTimeStamp)){
      disable = true;
    }
    return disable;
  }

  isEmptyString(val: string){
    return (!val || val==null || val==='')
  }

  isEmptyDate(val: Date){
    return (!val || val==null)
  }

  isValidProcessStep(stepName: string): boolean {
    return (this.selectedBeadChipStepsMap.get(stepName) != undefined && this.selectedBeadChipStepsMap.get(stepName) != null);
  }

  isValidProcessStepAction(stepName: string, actionName: string){
    return ( this.selectedBeadChipStepsMap.get(stepName) != undefined && this.selectedBeadChipStepsMap.get(stepName) != null);
  }

  getProcessStepStartPuid(stepName: string): string {
    return this.selectedBeadChipStepsMap.get(stepName).startPUID;
  }

  getProcessStepEndPuid(stepName: string): string {
    return this.selectedBeadChipStepsMap.get(stepName).endPUID;
  }

  getProcessStepStartTimestamp(stepName: string): Date {
    return this.convertUtcToLocal(this.selectedBeadChipStepsMap.get(stepName).startTimeStamp);
  }

  getProcessStepEndTimestamp(stepName: string): Date {
    return this.convertUtcToLocal(this.selectedBeadChipStepsMap.get(stepName).endTimeStamp);
  }

  getProcessStepActionPuid(stepName: string, actionName: string){
    return this.selectedBeadChipStepsMap.get(stepName).actionMap.get(actionName).actionPUID;
  }

  getProcessStepActionTimeStamp(stepName: string, actionName: string){
    return this.convertUtcToLocal(this.selectedBeadChipStepsMap.get(stepName).actionMap.get(actionName).actionStartTime);
  }

  calculateRemainingTimeForAction(stepName: string, actionName: string){
    var stepsMap = this.multiBeadChip ? this.multiBeadChipStepsMap : this.selectedBeadChipStepsMap;
    if (stepsMap.get(stepName).actionMap && stepsMap.get(stepName).actionMap.get(actionName) != undefined && stepsMap.get(stepName).actionMap.get(actionName) != null) {
      let actionStartTime: Date = this.getProcessStepActionTimeStamp(stepName, actionName);
      let actionRunTime: number = stepsMap.get(stepName).actionMap.get(actionName).actionRunTime;
      return this.calculatingTimes(this.calculateRemainingTime(actionRunTime, actionStartTime));
    } else {
      let actionRunTime = this.mapOfActionRuntime.get(actionName);
      return this.calculatingTimes(actionRunTime * 60);
    }
  }
  

  calculateRemainingTime(actionRunTime: number, actionStartTime: Date) {
    let currentDateLocal = new Date();
    if(actionStartTime.getTime()+actionRunTime*60*1000 <= currentDateLocal.getTime()){
      return 0;
    }
    return (actionStartTime.getTime()+actionRunTime*60*1000 - currentDateLocal.getTime())/1000;
  }

  convertUtcToLocal(date: any): Date{
    if(!date || date==null) return;
    if(date[date.length - 1] == 'Z')
      date = date.substring(0,date.length-1)
    var offset = new Date().getTimezoneOffset();
    let dateInLocal = new Date(date);
    dateInLocal.setMinutes(dateInLocal.getMinutes()-offset);
    return dateInLocal;
  }

  showChemicalPopup(open: boolean, processStep?: string) {
    this.showDialogue= true;
    this.selectedProcessStep = processStep;
    this.masterDataService.getAllActiveChemicals(this.selectedLabId, "chemical").subscribe({
      next : (result) => {
      this.processStepChemicals = result.data.filter(chemical => (chemical.processStep === processStep));
    }, error: (error: any) => {
      this._messagesService.addErrorMessage({ severity: 'error', summary: 'Error', detail: error.error });
    }});
    
    if(this.selectedBeadChipPlate.status && !this.mapOfProcessStepsStatus.get(this.selectedBeadChipPlate.status).includes(processStep) || this.selectedBeadChipPlate.status == null){
      this.noChemicalEdit = true;
    } else {
      this.noChemicalEdit = false;
    }

    if(this.lastUpdatedStatus && !this.mapOfProcessStepsStatus.get(this.lastUpdatedStatus).includes(processStep) || this.lastUpdatedStatus == null || this.lastUpdatedStatus == '' || this.selectedBeadChipPlate.plateID){
      this.multiChemicalEdit = false;
    } else {
      this.multiChemicalEdit = true;
    }
  }

  hideDialog(){
    this.showCommentDialog = false;
  }

  showMultiComments(){
    this.showMultipleCommentDialog = true;
  }

  saveMultiCommentEnabled(){
    return (this.newMultiComment == null || this.newMultiComment.trim() == '')
  }

  saveMultiComment(){
    let multiComment = new MultiCommentDTO();
    multiComment.plateids = []
    multiComment.status = this.lastUpdatedStatus;
    multiComment.comment = this.newMultiComment;
    multiComment.labid = this.selectedLabId;
    multiComment.platecomment = true;
    multiComment.puid = this.puid;
    multiComment.beadchipstatus = "";
    multiComment.beadchipids = [];
    for(var i=0;i<10;i++){
      if(this.lastUpdatedBeadChips1[i]['BeadChipId'] != '')
        multiComment.plateids.push(this.lastUpdatedBeadChips1[i]['BeadChipId']);
      if(this.lastUpdatedBeadChips2[i]['BeadChipId'] != '')
        multiComment.plateids.push(this.lastUpdatedBeadChips2[i]['BeadChipId']);
      if(this.lastUpdatedBeadChips3[i]['BeadChipId'] != '')
        multiComment.plateids.push(this.lastUpdatedBeadChips3[i]['BeadChipId']);
    }

    this.platePreparationService.updateMultiComment(multiComment).subscribe(
      (result) =>{
        this.newMultiComment = "";
        this.showMultipleCommentDialog = false;
        this._messagesService.addSuccessMessage({ severity: 'success', summary: 'Success', detail: result })
      },
      (error) =>{
        this._messagesService.addErrorMessage({ severity: 'error', summary: 'Error', detail: error.error })
      }
    );
  }

  hideChemicalDialog(beadChip: Plate){
    this.showDialogue = false;
    if (beadChip.plateID !== undefined)
      this.searchForBeadChipAction(beadChip.plateID);
  }

  showComments(){
    this.beadChipCommentsDisplayMap.clear();
    this.beadChipCommentsDisplayMap.set("showPlateCommentList",false)
    this.beadChipCommentsMap.clear();
    this.platePreparationService.commentDetailsbyPlateId(this.selectedLabId,this.selectedBeadChipPlate.plateID).subscribe(
      (result)=>{
        this.fetchedCommentsPlate = result;
        this.selectedPlateID = this.fetchedCommentsPlate.plateID;
        this.selectedBeadchip = this.fetchedCommentsPlate.beadChips;
        this.selectedBeadchipStatus = this.selectedBeadChipPlate.status;
        this.plateCommentsList = this.fetchedCommentsPlate.comments;
        if(this.fetchedCommentsPlate && this.fetchedCommentsPlate.beadChips){
          this.fetchedCommentsPlate.beadChips.forEach(beadChip=>{
            this.beadChipCommentsMap.set(beadChip.beadChipID,beadChip.comments)
            this.beadChipCommentsDisplayMap.set(beadChip.beadChipID,false);
          })
        }
        this.showCommentDialog = true;
      },
      (error)=>{
        this._messagesService.addErrorMessage({ severity: 'error', summary: 'Error', detail: error.error });
      }
    )
  }

  removeBeadChipSelection(){
    this.beadChipViewSelected = false
    this.multiBeadChip = true;
    this.beadChipSelectedRow = null;
    this.selectedBeadChipPlate = new Plate();
    this.selectedBeadChipStepsMap = new Map();
    this.clearLiquidHandlerValues();
  }

  onFileSelect(filesData) {
    if (filesData.target.files.length > 0) {
      const file = filesData.target.files[0];
      this.uploadedFile = file;
      let fileReader: FileReader = new FileReader();
      let self = this
      fileReader.onloadend = function(x) {
        self.uploadedFileContent = fileReader.result
        self.isFileNotSelected = false
      }
      fileReader.readAsText(file)
    } else {
      this.isFileNotSelected = true;
    }
  }

  fileUpload() {
    this.blocked = true;
    const formData = new FormData();
    formData.append('file', this.uploadedFile);
    this.platePreparationService.logFileUpload(this.uploadedFileContent, this.selectedLabId, this.puid).subscribe(
      results => {
        this.blocked = false;
        this._messagesService.addSuccessMessage({
          severity: 'success', summary: "Success", detail: results["data"]
        });
        this.fileUploadElement.nativeElement.value = "";
        this.isFileNotSelected = true;
        if(this.selectedBeadChipPlate.plateID){
          this.searchForBeadChipAction(this.selectedBeadChipPlate.plateID);
        }
        this.onApplyBeadChipFilter();
      }, 
      error => {
        this.fileUploadElement.nativeElement.value = "";
        this.isFileNotSelected = true;
        this.blocked = false;
        this._messagesService.addErrorMessage({ severity: 'error',
        summary: "Conflict", detail:error.error});
      }
    );
  }

  getProcessStepLiquidHandler(stepName){
    let stepsMap = this.multiBeadChip ? this.multiBeadChipStepsMap : this.selectedBeadChipStepsMap;
    return stepsMap.get(stepName) ? stepsMap.get(stepName).liquidHandler : "";
  }

  clearLiquidHandlerValues(){
    this.extensionLiquidHandler = '';
    this.multiLiquidHandler = '';
  }

  updateMachine(barcode, processStep, workFlow){
    if(barcode != '' || barcode == null){
      let selectedMachine = this.machinesList.find(element => barcode===element.barcode);
      if(selectedMachine !== undefined){
        selectedMachine.latestProcessStep = processStep;
        selectedMachine.latestProcessStepTimeStamp = new Date();
        selectedMachine.latestWorkFlow = workFlow;
        this.blocked = false;
        this.masterDataService.updateConfig(selectedMachine.lab, selectedMachine, "machine").subscribe(
          results => {
            this.blocked = false;
            if (!results) {
              return;
            }
            this.machinesList[this.machinesList.indexOf(selectedMachine)] = results.data
          },
          error => {
            this.blocked = false;
            this._messagesService.addErrorMessage({
              severity: 'error', summary: 'Error in updating Machine',
              detail: "Error in updating machine status."
            });    
          }
        );
      }
      else{
        this._messagesService.addWarningMessage({
          severity: 'warn', summary: 'Machine Does Not Exists',
          detail: "Machine with the given barcode does not exist."
        });
      }
    }
  }
}
